let unavailable = false;
let retryTimer: ReturnType<typeof setTimeout> | undefined;
const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) listener();
}

export function subscribeStreamAvailability(listener: () => void): () => void {
  listeners.add(listener);

  return (): void => {
    listeners.delete(listener);
  };
}

export function isStreamAvailable(): boolean {
  return !unavailable;
}

export function markStreamRefused(retryAfterMs: number): void {
  if (retryTimer) clearTimeout(retryTimer);
  retryTimer = setTimeout(markStreamAvailable, retryAfterMs);

  if (unavailable) return;
  unavailable = true;
  emit();
}

export function markStreamAvailable(): void {
  if (retryTimer) {
    clearTimeout(retryTimer);
    retryTimer = undefined;
  }

  if (!unavailable) return;
  unavailable = false;
  emit();
}
